/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

import MedicineListHeader from "components/ClinicalManagement/Medicines/MedicineListHeader/MedicineListHeader";

const MedicinesListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Medicine")}
          />
          <div className="container-fluid px-lg-5">
            <MedicineListHeader />
          </div>

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default MedicinesListBody;
